export default "__VITE_ASSET__35de1ea0__"